const validateAgentForm = ({ formData, customMessage = false }) => {
  const errors = {};

  // Helpers
  const isEmpty = (value) => !value?.trim();
  const matchRegex = (value, regex) => regex.test(value);
  const getMsg = (field, defaultMsg, fallback) =>
    customMessage ? fallback || `Invalid ${field}` : defaultMsg;

  // Patterns
  const regex = {
    name: /^[a-zA-Z0-9\s\-()&-',.]{1,40}$/,
    agencyName: /^[a-zA-Z0-9\s\-()&-',.]{1,40}$/,
    address: /^[a-zA-Z0-9\s,.\-#'()]{1,100}$/,
    city: /^[a-zA-Z0-9\s\-()&-',.]{1,50}$/,
    zip: /^\d{5}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^\d{10}$/,
    license: /^[a-zA-Z0-9\s,.:;\-|#'()]{1,50}$/,
  };

  // Field Validator
  const validateField = (
    key,
    label,
    value,
    pattern,
    requiredMsg,
    invalidMsg
  ) => {
    if (value !== undefined) {
      if (isEmpty(value)) {
        errors[key] = getMsg(label, requiredMsg, invalidMsg);
      } else if (pattern && !matchRegex(value, pattern)) {
        errors[key] = invalidMsg;
      }
    }
  };

  // Name & Corporation Fields
  validateField(
    "firstName",
    "Name",
    formData.firstName,
    regex.name,
    "First name is required",
    "Invalid Name"
  );
  validateField(
    "lastName",
    "Name",
    formData.lastName,
    regex.name,
    "Last name is required",
    "Invalid Name"
  );
  validateField(
    "corporationName",
    "Agency Name",
    formData.corporationName,
    regex.agencyName,
    "Agency name is required",
    "Invalid Agency Name"
  );

  // Address, City, State, Zip
  validateField(
    "address1",
    "Corporation Address",
    formData.address1,
    regex.address,
    "Address is required",
    "Invalid Corporation Address"
  );
  validateField(
    "city",
    "City",
    formData.city,
    regex.city,
    "City is required",
    "Invalid City"
  );

  if (formData.state !== undefined && !formData.state) {
    errors.state = getMsg(
      "State",
      "State is required",
      "Please select a state"
    );
  }

  validateField(
    "zip",
    "ZIP",
    formData.zip,
    regex.zip,
    "ZIP code is required",
    "Invalid Zip Code"
  );

  // Contact
  validateField(
    "emailId",
    "Email",
    formData.emailId,
    regex.email,
    "Email is required",
    "Invalid Email"
  );

  // License
  validateField(
    "individualLicencenNumber",
    "Individual Licence Number",
    formData.individualLicencenNumber,
    regex.license,
    "Individual Licence Number is required",
    "Invalid Individual Licence Number"
  );

  const phone = formData.phoneNumber?.replace(/\D/g, "");
  validateField(
    "phoneNumber",
    "Phone Number",
    phone,
    regex.phone,
    "Phone number is required",
    "Invalid Phone Number"
  );

  // License expiry
  if (formData.individualLicenceExpiryDate != undefined) {
    if (!formData.individualLicenceExpiryDate) {
      errors.individualLicenceExpiryDate = "Invalid Licence expiry date";
    } else {
      const expiryDate = new Date(formData.individualLicenceExpiryDate);
      const today = new Date();
      if (expiryDate < today) {
        errors.individualLicenceExpiryDate = "License has expired";
      }
    }
  }

  // License state
  ["selectIndividualLicenceState", "individualLicenceState"].forEach((key) => {
    if (formData[key] !== undefined && !formData[key]?.trim()) {
      errors[key] = "Please select License state";
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export default validateAgentForm;
